import React from 'react'

import { FullWidthCard } from '../../../react4xp/components/cards/FullWidthCard'

export default (props) => {
    return <FullWidthCard {...props} />
}
